class BESSAppProjectProfilerData {

    constructor(data) {
        this.origData = data;
        this.editorId = data['editor_id']
        this.target = data['target']
        this.title = data['title'];
        this.projectWideEdit = data['project_wide_edit'];
        this.allowCreateDeleteItems = data['allow_create_delete_items'];
        this.what = data['what'];
        this.whatPlural = data['what_plural'];
        this.fields = _.map(data.fields, (x) => new BESSAppProjectProfilerFieldData(x));
        this.items = _.map(data.items, (x) => new BESSAppProjectProfilerItemData(x));
        this.itemsOrig = [...this.items];
        this.snipit = data['snipit'];
        this.toolNotesReference = data['tool_notes_reference']
        this.userGuideReference = data['user_guide_reference']
        this.tags = data['tags'];
        this.dependencies = _.map(data['dependencies'], (x) => new BESSAppProjectProfilerDependencyData(x));
        this.creditSectionDependencies = _.map(data['credit_section_dependencies'], (x) => new BESSAppProjectProfilerDependencyData(x));

        _.each(this.fields, function (field, fieldNo) {
            _.each(this.items, function (item) {
                item.valueFor[field.variable] = item.values[fieldNo];
            });
        }.bind(this));
    }

    createProjectWideItem() {
        return new BESSAppProjectWideProfilerItemData(this.fields, this.items)
    };

    appendNewItem() {
        let newItem = BESSAppProjectProfilerItemData.createNew(this.fields, this.what, this.items.length + 1);
        this.items.push(newItem);
        if (this.fields[0].placeholder === "(Auto-assign)") {
            newItem.values[0].value = this.what + ' ' + this.items.length;
        }
        return newItem;
    }

    copyItem(itemData) {
        let newItem = itemData.createCopy();
        this.items.splice(itemData.itemIndex + 1, 0, newItem);
        this.#rebuildItemIndexes();
        return newItem;
    }

    removeItem(itemData) {
        _.pull(this.items, itemData);
        this.#rebuildItemIndexes();
    }

    hasChanges() {
        return this.itemsOrig.length !== this.items.length ||
            this.#hasNewItems() ||
            this.#hasOrderChanged()
    }

    clone() {
        return new BESSAppProjectProfilerData(this.origData);
    }

    toData() {
        return {
            'editor_id': this.editorId,
            'target': this.target,
            'items': _.map(this.items, (x) => x.toData()),
        }
    }


    getWhat(quantity) {
        return pluralise(this.what, this.whatPlural, quantity);
    }

    #hasNewItems() {
        return this.items.find((x) => x.isNew) !== undefined;
    }

    #hasOrderChanged() {
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i] !== this.itemsOrig[i]) {
                return true;
            }
        }
        return false;
    }

    #rebuildItemIndexes() {
        for (let i = 0; i < this.items.length; i++) {
            this.items[i].itemIndex = i;
        }
    }

    getFieldNoForAttribute(attribute) {
        return _.findIndex(this.fields, (x) => x.variable === attribute);
    }

    getFieldForAttribute(attribute) {
        return _.find(this.fields, (x) => x.variable === attribute);
    }

    distinctItemValues(attribute) {
        let fieldNo = _.findIndex(this.fields, (x) => x.variable === attribute);
        let distinct = [];
        if (fieldNo !== undefined && fieldNo >= 0) {
            let field = this.fields[fieldNo];
            let choices = field.inputType === BESSAppInputType.choice ? field.choices : null;
            _.each(this.items, function (item) {
                let value = item.values[fieldNo].value;
                if (choices != null && value !== null) {
                    let choice = field.findChoiceMatching(value);
                    if (choice != null) {
                        value = choice.value
                    }
                }
                if (value !== null && value !== '' && !distinct.includes(value)) {
                    distinct.push(value)
                }
            });
        }
        distinct.sort();
        return distinct;
    }
}